var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_error"},[_c('div',[_c('v-icon',{staticClass:"error_icon"},[_vm._v("memory")])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_text"},[_c('h1',[_vm._v("500")]),_c('h3',[_vm._v("Erro interno")]),_c('p',[_vm._v("Há um problema com o recurso que você está procurando, ele não pode ser exibido.")])])
}]

export { render, staticRenderFns }